import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, IconButton } from '@material-ui/core';
import { T } from 'Actions/translate';
import BasicButton from 'Components/common/BasicButton';
import { ArrowBackIos } from '@material-ui/icons';
import { submitFeedback } from 'Actions/userCenter';
import { openNotification } from 'Actions/notification';
import BasicTextArea from '../common/BasicTextArea';

class Feedback extends Component {

	state = {
		loading: false,
		chosed: true,
		message: ''
	}

	handleChange = (name, value) => {
		if(value !== ''){
			this.setState({
				chosed: false,
				message: value
			});
		} else {
			this.setState({ chosed: true });
		}
	};

	submitFeedback = () => {
		const params = {};
		params.message =  this.state.message;
		this.setState({
			loading: true,
			chosed: true,
		 });
		this.props.submitFeedback(params).then(() => {
			this.setState({
				loading: false,
				chosed: true,
				message: ''
			});

			this.props.openNotification(T('notification_feedback_submitted_successfully'), 'success');

			setTimeout(() => {
				this.props.history.push('/userCenter');
			},3000)
		}).finally(() => {
			this.setState({
				loading: false,
				chosed: false,
			});
		});;
	}

    render() {
      	const { chosed, loading } = this.state;

      	return (
	      	<div className='feedback'>

	      		<Grid className='ship-to-head container-max-width is-fixed' container spacing={0} justify={'space-evenly'}>

		        	<Grid className='back-icon' item xs={3}>
								<IconButton color='inherit' onClick={() => this.props.history.push('/userCenter')}>
		         			<ArrowBackIos/>
		         		</IconButton>
		        	</Grid>

		        	<Grid className='page-title' item xs={9}>
		            	<span>{T('feedback')}</span>
		        	</Grid>

	      		</Grid>

				<div className="content">
					<section className="feedback-content content-box">
						<span className='feedback-title'>{T('feedback_write_here')}</span>
						<Grid container spacing={0} justify={'center'}>
							<Grid item xs={12}>
								<BasicTextArea
									title={'feedback'}
									placeholder=''
									inputValid={this.handleChange}
									rows='8'
								/>
							</Grid>
						</Grid>
					</section>
				</div>

		      	<Grid className='confirm-select' container spacing={0} justify={'center'}>
		      		<Grid item xs={4}>
						<BasicButton className='feed-back-btn' loading={loading} type="primary" disabled={!chosed ? false : true} onClickOfSingleTap={this.submitFeedback}>
		        			<span>{T('feedback_confirm')}</span>
		        		</BasicButton>
	                </Grid>
				</Grid>
	      	</div>
      );
    }

}

const mapStateToProps = state => {
  	return {};
};

const mapDispatchToProps = {
	submitFeedback,
	openNotification
};

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);
